var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inline-svg',{class:{
      invalid1: _vm.isInvalid(0),
      focused1: _vm.isFocused(0),
      invalid2: _vm.isInvalid(1),
      focused2: _vm.isFocused(1),
      invalid3: _vm.isInvalid(2),
      focused3: _vm.isFocused(2)
    },attrs:{"src":require(`../../assets/dimensions/elements/${_vm.imagePath}`)},on:{"loaded":_vm.setupClickListeners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }